import { ReactNode } from "react";

export function Td({ children, ...rest }: { children: ReactNode } & Record<string, any>): JSX.Element {
	return (
		<td className="border border-neutral-high-200 md:p-1" {...rest}>
			{children}
		</td>
	);
}

export function Th({ children, ...rest }: { children: ReactNode } & Record<string, any>): JSX.Element {
	return (
		<th className="border border-neutral-high-200 md:p-1" {...rest}>
			{children}
		</th>
	);
}

export function OrderedTitle({ marker = "•", children }: { marker: string; children: ReactNode }): JSX.Element {
	return (
		<span className="uppercase">
			<span className="font-semibold w-[2.5rem] inline-block">{marker}</span>
			{children}
		</span>
	);
}

export function Ordered({ children }: { children: ReactNode }): JSX.Element {
	return <ol className="pl-2">{children}</ol>;
}

export function Item({
	marker = "•",
	leadingText = "",
	children
}: {
	marker?: string;
	leadingText?: string | ReactNode;
	children: ReactNode;
}): JSX.Element {
	return (
		<li className="py-1" style={{ listStyleType: "none" }}>
			<span className="font-semibold w-[2.5rem] inline-block">{marker}</span>
			<span className="font-semibold">{leadingText}</span> {children}
		</li>
	);
}
